import React, { useState, useEffect } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import "../../../../components/common/css/new.scss";
import "../../../../components/common/css/add.scss";

const AddCategory = () => {
  const [loading, setLoading] = useState(false);
  let token = localStorage.getItem("accessToken");
  const navitage = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  const onSubmit = (data) => {
    setLoading(true);
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "admin/save-categories",
      headers: {
        "x-access-token": token,
      },
      data: {
        category_name: data.name,
        category_title: data.title,
        category_description: data.description,
      },
    };

    axios(config)
      .then(function (response) {
        setLoading(false);
        if (response.data.status === 200) {
          Swal.fire({
            title: response.data.message,
            timer: 2500,
            timerProgressBar: true,
            icon: "success",
            confirmButtonText: "OK",
            showCloseButton: true,
          });
          navitage("/categories");
        }
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error.response.data.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <Loader isLoading={loading} />
        <div className="bottom">
          <div className="modal-content">
            <div className="modal-content-title">Add New Category</div>
            <p>&nbsp;</p>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="custome-form-group">
                <label>Category Name</label>
                <input
                  type="text"
                  name="name"
                  placeholder="Enter Category Name"
                  {...register("name", {
                    required: "Name is  required",
                    minLength: {
                      value: 2,
                      message: "Name must be 5 characters",
                    },
                    maxLength: {
                      value: 20,
                      message: "Name must be 20 characters",
                    },
                    pattern: {
                      value: /^[a-zA-Z_ ]*$/,
                      message: "Please enter only characters",
                    },
                  })}
                  className="custome-input"
                />
                {errors.name && (
                  <div className="invalid-feedback">{errors.name.message}</div>
                )}
              </div>
              <div className="custome-form-group">
                <label>Category Title</label>
                <input
                  type="text"
                  name="title"
                  placeholder="Enter Category Title"
                  {...register("title", {
                    required: "Title is required",
                    minLength: {
                      value: 2,
                      message: "Title must be 5 characters",
                    },
                    maxLength: {
                      value: 20,
                      message: "Title must be 20 characters",
                    },
                    pattern: {
                      value: /^[a-zA-Z_ ]*$/,
                      message: "Please enter only characters",
                    },
                  })}
                  className="custome-input"
                />
                {errors.title && (
                  <div className="invalid-feedback">{errors.title.message}</div>
                )}
              </div>
              <div className="custome-form-group">
                <label>Category Description</label>
                <textarea
                  minRows={5}
                  className="custome-input"
                  name="description"
                  {...register("description", {
                    required: "Description is required",
                    pattern: {
                      value: /^[a-zA-Z_ ]*$/,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter Category Description"
                ></textarea>
                {errors.description && (
                  <div className="invalid-feedback">
                    {errors.description.message}
                  </div>
                )}
              </div>
              <button type="submit" className="approveButton">
                Save
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCategory;
